import SVGInject from '@iconfu/svg-inject';
//Inject the svg
SVGInject(document.querySelectorAll("img[data-inject-svg]"));